import R, { useMemo as w, useRef as f, useEffect as v, forwardRef as C, useImperativeHandle as E } from "react";
import { OverlayScrollbars as I } from "overlayscrollbars";
const O = () => {
  if (typeof window > "u") {
    const n = () => {
    };
    return [n, n];
  }
  let l, c;
  const t = window, o = typeof t.requestIdleCallback == "function", a = t.requestAnimationFrame, i = t.cancelAnimationFrame, r = o ? t.requestIdleCallback : a, u = o ? t.cancelIdleCallback : i, s = () => {
    u(l), i(c);
  };
  return [
    (n, e) => {
      s(), l = r(
        o ? () => {
          s(), c = a(n);
        } : n,
        typeof e == "object" ? e : { timeout: 2233 }
      );
    },
    s
  ];
}, S = (l) => {
  const { options: c, events: t, defer: o } = l || {}, [a, i] = w(O, []), r = f(null), u = f(o), s = f(c), n = f(t);
  return v(() => {
    u.current = o;
  }, [o]), v(() => {
    const { current: e } = r;
    s.current = c, I.valid(e) && e.options(c || {}, !0);
  }, [c]), v(() => {
    const { current: e } = r;
    n.current = t, I.valid(e) && e.on(t || {}, !0);
  }, [t]), v(
    () => () => {
      var e;
      i(), (e = r.current) == null || e.destroy();
    },
    []
  ), w(
    () => [
      (e) => {
        const y = r.current;
        if (I.valid(y))
          return;
        const d = u.current, b = s.current || {}, m = n.current || {}, p = () => r.current = I(e, b, m);
        d ? a(p, d) : p();
      },
      () => r.current
    ],
    []
  );
}, F = (l, c) => {
  const { element: t = "div", options: o, events: a, defer: i, children: r, ...u } = l, s = t, n = f(null), e = f(null), [y, d] = S({ options: o, events: a, defer: i });
  return v(() => {
    const { current: b } = n, { current: m } = e;
    return b && m && y({
      target: b,
      elements: {
        viewport: m,
        content: m
      }
    }), () => {
      var p;
      return (p = d()) == null ? void 0 : p.destroy();
    };
  }, [y, t]), E(
    c,
    () => ({
      osInstance: d,
      getElement: () => n.current
    }),
    []
  ), // @ts-ignore
  /* @__PURE__ */ R.createElement(s, { "data-overlayscrollbars-initialize": "", ref: n, ...u }, /* @__PURE__ */ R.createElement("div", { "data-overlayscrollbars-contents": "", ref: e }, r));
}, A = C(F);
export {
  A as OverlayScrollbarsComponent,
  S as useOverlayScrollbars
};
//# sourceMappingURL=overlayscrollbars-react.mjs.map
